export default {
  maintenance: '/*'
}



// WEBPACK FOOTER //
// ./src/routes/maintenance/maintenanceRoutes.js